import urlTool from '@/tools/url';
import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/collection
 * @alias get
 *
 * @description
 * Получение информации о коллекции
 *
 * @param {string} handle - пермалинк коллекции, объязателен.
 * @param {Object} filter - объект с выбранными параметрами для фильтрации
 * @param {Object} pager - объект с настройками пагинации
 * @param {number} pager.page_size - размер разбивки на страницы
 * @param {number} pager.page - номер страницы, по которой получаем информацию
 *
 * @return {Promise}
 * { status: "ok", count: 19, products: [//массив товаров]}
 *
 * @example
 * const filter = {
 *   price_min: 4000,
 *   price_max: 10000
 * };
 *
 * const pager = {
 *   page_size: 25,
 *   page: 2
 * }
 *
 * ajaxAPI.collection.get('collection_handle', filter, pager)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(collection, filter, pager) {
  const lang = urlTool.getKeyValue('lang') || '';
  const request_url = `${window.location.origin}/collection/${collection.toString()}.json`;

  let params = Object.assign({}, filter, pager);
  let path = new URL(request_url);

  if (lang) {
    params.lang = lang;
  }

  Object.keys(params).forEach(key => {
    if (Array.isArray(params[key])) {
      params[key].forEach(value => {
        path.searchParams.append(key, value);
      });
    } else {
      path.searchParams.set(key, params[key]);
    }
  });

  return fetchJQueryAdapter(path).updateResponse((response) => {
    if (response) {
      response.products.forEach((product) => {
        if (product && lang) {
          product.url += '?lang=' + lang;
        }
      });
    }
  });
}
